import React from "react";
import { MdDelete } from "react-icons/md";

function DeleteModal({ isOpen, onClose, onConfirm }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
      
      {/* Modal Box */}
      <div className="bg-white rounded-2xl p-6 w-[400px] text-center shadow-lg">
        
        {/* Delete Icon */}
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center">
            <MdDelete className="text-red-600 text-3xl" />
          </div>
        </div>

        {/* Title */}
        <h2 className="text-lg font-semibold">
          Are you sure?
        </h2>

        {/* Description */}
        <p className="text-sm text-gray-600 mt-2 mb-6">
          Do you want to delete this template?
        </p>

        {/* Buttons */}
        <div className="flex justify-center gap-4">
          
          {/* Delete Button */}
          <button
            onClick={onConfirm}
            className="px-5 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
          >
            Yes, Delete it
          </button>

          {/* Cancel Button */}
          <button
            onClick={onClose}
            className="px-5 py-2 bg-gray-300 text-black rounded-lg hover:bg-gray-400 transition"
          >
            Cancel
          </button>

        </div>
      </div>
    </div>
  );
}

export default DeleteModal;